import { httpClient } from "./client";


const API_ENDPOINT = "/category";

export const getListOfCategories = async () => {
    const response = await httpClient.get(`${API_ENDPOINT}`);
    return response;
}